import React from 'react';
import { useDispatch } from 'react-redux';
import { openQueueProperties } from '../api';
import { useSelector } from '../hook-utils';
import { openQueueForwardDialogSingle, openQueueStatusDialogSingle } from '../legacy';
import { ExtensionStatus, QueueStats } from '../model';
import { actions } from '../store';
import { selectMyAccess, selectMyself } from '../store/reducers/config';
import { selectExtension } from '../store/reducers/queueAgents';
import { selectFavQueues } from '../store/reducers/queues';
import { ReactComponent as DialIcon } from './icons/dial.svg';
import { ReactComponent as FavRemoveIcon } from './icons/favourite-remove.svg';
import { ReactComponent as FavIcon } from './icons/favourite.svg';
import { ReactComponent as QueuePropsIcon } from './icons/queue-props.svg';
import { ReactComponent as QueueCloseEarlyIcon } from './icons/queue/close-early.svg';
import { ReactComponent as QueueSetEmergencyIcon } from './icons/queue/emergency.svg';
import { ReactComponent as QueueForwardMessageIcon } from './icons/queue/forward-message.svg';
import { ReactComponent as QueueForwardQueueIcon } from './icons/queue/forward-queue.svg';
import { ReactComponent as QueueSetHolidayIcon } from './icons/queue/holiday.svg';
import { ReactComponent as QueueOpenEarlyIcon } from './icons/queue/open-early.svg';
import { ReactComponent as QueueOpenIcon } from './icons/queue/open.svg';
import { ReactComponent as QueueRestIcon } from './icons/queue/reset.svg';
import { ReactComponent as StatsIcon } from './icons/stats.svg';
import { ReactComponent as VoicemailIcon } from './icons/voicemail.svg';
import { Menu, MenuDivider, MenuItem, MenuTarget } from './Menu';
import css from './QueueMenu.module.scss';
import { selectInIpfxClient } from '../store/reducers/localSettings';

export type QueueMenuState = { target?: MenuTarget, queue?: QueueStats }

export function QueueMenu({ target, onClose, queue, onClick }: QueueMenuState & { onClose(): void, onClick?(): void }) {
  return <Menu open={Boolean(queue)} onClose={onClose} target={target || null} className={css.QueueMenu} onClick={onClick}>
    <QueueMenuItems queue={queue} />
  </Menu>
}

export function QueueMenuItems({ queue }: QueueMenuState) {
  const dispatch = useDispatch()
  const favQueues = useSelector(selectFavQueues)
  const access = useSelector(selectMyAccess)
  const myId = useSelector(selectMyself);
  const myself = useSelector(s => myId ? selectExtension(s, myId) : undefined)
  const electron = useSelector(selectInIpfxClient)

  function onFav(add: boolean) {
    if (queue) {
      dispatch(actions.favouriteQueue(queue, add))
    }
  }

  if (!queue || !myId || !myself) { return null }

  return <>
    {access.features.phoneDial && (myself.status === ExtensionStatus.None || myself.status === ExtensionStatus.Released) && <MenuItem onClick={() => dispatch(actions.ccDial(queue.id))}>
      <DialIcon />
      Dial queue
    </MenuItem>}
    {(access.features.extensionViewOtherVoicemail && myId.server === queue.server) && <MenuItem onClick={() => dispatch(actions.openVoiceMail(queue))}>
      <VoicemailIcon />
      View voicemail
    </MenuItem>}
    {access.features.queuesRouting && <>
      <MenuDivider />
      <MenuItem onClick={() => openQueueStatusDialogSingle(myId, queue, 'open')}>
        <QueueOpenIcon />
        Open
    </MenuItem>
      <MenuItem onClick={() => openQueueStatusDialogSingle(myId, queue, 'openearly')}>
        <QueueOpenEarlyIcon />
        Open Early
    </MenuItem>
      <MenuItem onClick={() => openQueueStatusDialogSingle(myId, queue, 'closeearly')}>
        <QueueCloseEarlyIcon />
        Close Early
    </MenuItem>
      <MenuDivider />
      <MenuItem onClick={() => openQueueForwardDialogSingle(myId, queue, 'queues')}>
        <QueueForwardQueueIcon />
        Forward To Queue
    </MenuItem>
      <MenuItem onClick={() => openQueueForwardDialogSingle(myId, queue, 'messagebox')}>
        <QueueForwardMessageIcon />
        Forward To Message
    </MenuItem>
      <MenuDivider />
      <MenuItem onClick={() => openQueueStatusDialogSingle(myId, queue, 'holiday')}>
        <QueueSetHolidayIcon />
        Set to Holiday Mode...
    </MenuItem>
      <MenuItem onClick={() => openQueueStatusDialogSingle(myId, queue, 'emergency')}>
        <QueueSetEmergencyIcon />
        Set to Emergency Mode...
    </MenuItem>
      <MenuDivider />
      <MenuItem onClick={() => openQueueStatusDialogSingle(myId, queue, 'reset')}>
        <QueueRestIcon />
        Reset
    </MenuItem>
    </>}
    <MenuDivider />
    {!favQueues.includes(queue) ?
      <MenuItem onClick={() => onFav(true)}>
        <FavIcon />
        Add to favourites
      </MenuItem>
      :
      <MenuItem onClick={() => onFav(false)}>
        <FavRemoveIcon />
        Remove from favourites
      </MenuItem>}

    <>
      <MenuDivider />
      <MenuItem onClick={() => dispatch(actions.openQueueStats(queue))}>
        <StatsIcon />
        Statistics
      </MenuItem>
    </>

    {access.features.configQueues && electron && <>
      <MenuDivider />
      <MenuItem onClick={() => openQueueProperties(queue)}>
        <QueuePropsIcon />
        Queue Properties
      </MenuItem>
    </>}
  </>
}
